// BAID stands for blanco application server session ID
// See also https://spdlybra.nintendo.co.jp/confluence/pages/viewpage.action?pageId=688037681

export interface Baid {
  token: string;
  expireAt: number; // UNIX time
}

export function validateBaid(token?: string, expireAt?: number): boolean {
  if (!token || !expireAt) {
    return false;
  }
  const currentUnixTime = Math.floor(new Date().getTime() / 1000);
  const offset = 5 * 60; // 5分のoffsetを設けて検証する
  return expireAt - offset > currentUnixTime;
}
